/**
 * Authentication Configuration
 * 
 * This file contains the configuration for user authentication and authorization.
 * PRODUCTION NOTE: In a production environment, move authorized emails to:
 * 1. Environment variables (.env file)
 * 2. Firebase Firestore collection for dynamic management
 * 3. External configuration service
 */

// List of authorized email addresses from environment variables
// Fallback to default list if environment variable is not set
const getAuthorizedEmails = () => {
  // Check if environment variable is set
  if (process.env.REACT_APP_AUTHORIZED_EMAILS) {
    // Split comma-separated emails and trim whitespace
    return process.env.REACT_APP_AUTHORIZED_EMAILS
      .split(',')
      .map(email => email.trim())
      .filter(email => email.length > 0); // Remove empty entries
  }
  
  // Fallback to default list for development
  return [
    'sinu2441@gmail.com',
    'marie@amurabi.eu',
    'sundar@amurabi.eu',
    'sandeep.vishwakarma@aitechethics.com',
    'guillemette@amurabi.eu',
    'bibin@amurabi.eu',
    'sundar.narayanan@aitechethics.com',
    'sai.bhatkar@aitechethics.com',
    'matthieu@amurabi.eu',
    'doa@amurabi.eu',
    'orla@fairpatterns.ai',
    'app@amurabi.eu'
  ];
};

export const AUTHORIZED_EMAILS = getAuthorizedEmails();

/**
 * Check if an email address is authorized to access the application
 * @param {string} email - The email address to check
 * @returns {boolean} - True if email is authorized, false otherwise
 */
export const isEmailAuthorized = (email) => {
  if (!email) return false;
  return AUTHORIZED_EMAILS.includes(email.toLowerCase().trim());
};

/**
 * Configuration for Firebase authentication
 */
export const authConfig = {
  // Enable persistence for authentication state
  enablePersistence: true,
  
  // Redirect URL after successful authentication (optional)
  redirectUrl: '/',
  
  // Custom claims and additional user metadata can be configured here
  customClaims: {
    // Add any custom claims you want to set for users
  }
};

/**
 * Error messages for authentication
 */
export const AUTH_ERRORS = {
  UNAUTHORIZED_EMAIL: 'Your email address is not authorized to access this application.',
  GENERAL_AUTH_ERROR: 'Authentication failed. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  POPUP_BLOCKED: 'Sign-in popup was blocked. Please allow popups and try again.',
};

export default {
  AUTHORIZED_EMAILS,
  isEmailAuthorized,
  authConfig,
  AUTH_ERRORS
};
